var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.size ? { width: (_vm.size + "px"), height: (_vm.size + "px") } : {}),attrs:{"src":_vm.imgs[_vm.name],"alt":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }